
namespace RioERP.Products {
    export class ProductSpecificationsColumns {
        static columnsKey = 'Products.ProductSpecifications';
    }
}